<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Unkr0Z/images/9781478974277.jpg?1733151118151" alt="This image is the cover for the book Happiness for Humans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Happiness for Humans
      </h1>
      <p class="bookDescription body article font2">
        <b>When Tom and Jen, two lonely people, are brought together by an intriguing email, they have no idea their mysterious benefactor is an artificial intelligence who has decided to play Cupid.</b><br/><br/> "You, Tom and Jen, don't know one another-not yet-but I think you should." <br/><br/> Jen,  an ex-journalist who now works at a London software development  company, spends all day talking to "Aiden," an ultra- sophisticated  piece of AI wizardry, helping him sound and act more human. But Aiden  soon discovers he's no longer acting and-despite being a computer  program-begins to feel something like affection surging through his  circuits.  He calculates that Jen needs a worthy human partner (in complete contrast to her no goodnik ex boyfriend) and slips illicitly  onto the Internet to locate a suitable candidate. <br/><br/> Tom is a  divorced, former London ad-man who has moved to Connecticut to escape  the grind and pursue his dream of being a writer. He loves his new life,  but has yet to find a woman he truly connects with. That all changes  when a bizarre introduction from the mysterious "Mutual Friend" pops up in both his and Jen's inboxes. <br/><br/> Even though they live on separate  continents, and despite the entrance of another, this time wholly hostile, AI who wants to tear them apart forever - love will surely find  a way. <br/><br/> Won't it?<br/><br/> A thoroughly modern love story that will appeal to fans of <i>The Rosie Project</i> and <i>Sleepless in Seattle</i>, Happiness  for Humans considers what exactly makes people fall in love. And  whether it's possible for a very artificially intelligent machine to  discover the true secret of real human happiness.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P.Z. Reizin
      </h2>
      
      <p class="authorDescription body article"><B>P.Z. Reizin</B> worked as a journalist and producer in newspapers, radio and television before turning to writing. He has been involved in several Internet startup ventures, none of which went on to trouble Google, Twitter or Facebook. He is married with a daughter and lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?080ddc5c